import React from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputField from "../../form/InputField";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import LoadingButton from "../../form/LoadingButton";
import SubmitButton from "../../form/SubmitButton";
import { useParams } from "react-router-dom";

export interface CarBrandFormData {
  languages: {
    languageCode: string;
    title: string;
  }[];
}

interface Props {
  defaultValues: CarBrandFormData;
  id:number;
  onSubmitSuccess?: () => void;
}

const UpdateCategoryForm: React.FC<Props> = ({ defaultValues, id,onSubmitSuccess }) => {
  const { t } = useTranslation();
    const { storeId} = useParams<{ storeId: string}>();
    const numericStoreId = storeId ? parseInt(storeId) : undefined;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<CarBrandFormData>({
    defaultValues, // prefill the form with provided values
  });

  
      const {loading,updateResource} = useUpdateResource();
  
    const onSubmit: SubmitHandler<CarBrandFormData> = async (data) => {
      const endPoint = numericStoreId ? `category/${id}?storeId=${numericStoreId}` : `category/${id}`
          await  updateResource(endPoint, data,  numericStoreId?"admin":"store",{
              method: "PUT",
              successMessage: t("update_success"),
              invalidateQueries:["product-categories-for-action","product-categories"],
            });
          if (onSubmitSuccess) onSubmitSuccess();
    };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="grid sm:grid-cols-2 gap-4"
    >
      {/* English Brand Name */}
      <InputField
        placeholder="Toyota"
        label={t("title_en")}
        register={register("languages.0.title", {
          required: t("required_field"),
        })}
        error={errors.languages?.[0]?.title}
      />

      {/* Arabic Brand Name */}
      <InputField
        placeholder="تويوتا"
        label={t("title_ar")}
        register={register("languages.1.title", {
          required: t("required_field"),
        })}
        error={errors.languages?.[1]?.title}
      />

       {
              loading
              ?
              <LoadingButton/>
              :
              <SubmitButton label={t("update")} />
      }
    </form>
  );
};

export default UpdateCategoryForm;
